import React, { useState, useEffect } from "react";
import Page from "../../common/layout/Page";
import DynamicPage from "../../common/DynamicPage/DynamicPage";

const LegalNotice = () => {
  return (
    <Page container="container-fluid px-5">
      <DynamicPage url="legal_notice" />
    </Page>
  );
};

export default LegalNotice;
